import * as tslib_1 from "tslib";
import { createSelector } from '@ngrx/store';
import * as cart from '../actions/cart';
import * as auth from '../../auth/actions/auth.actions';
import * as checkout from '../../checkout/actions/checkout';
import { ABSOLUTE_QUANT, ThemeConfig } from '../../core/helpers/theme-config';
var quantityType = ThemeConfig.get('catalog', 'quantity-type');
var initialState = {
    order: null,
    cartIndex: [],
    cartProducts: {}
};
function calculateQuantity(line) {
    if (quantityType === ABSOLUTE_QUANT)
        return line.quantity;
    return line.quantity / line.stepping;
}
function calculateRelativeQuantity(line) {
    var quantity = line.quantity;
    var stepping = line.stepping || 1;
    return quantity / stepping;
}
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    var _a;
    switch (action.type) {
        case cart.ADD:
            var inCart = (state.cartProducts[action.payload.product]
                && state.cartProducts[action.payload.product].inCart) || false;
            var quantity = (state.cartProducts[action.payload.product]
                && state.cartProducts[action.payload.product].quantity) || 0;
            var stepping = (state.cartProducts[action.payload.product]
                && state.cartProducts[action.payload.product].stepping) || 1;
            var relativeQuantity = (state.cartProducts[action.payload.product]
                && state.cartProducts[action.payload.product].relativeQuantity) || 0;
            // Create new cartIndex. Check if item already was in cart (so no duplicates will be in cartIndex)
            var newCartIndex = state.cartIndex.slice();
            if (newCartIndex.indexOf(action.payload.product) === -1) {
                newCartIndex.push(action.payload.product);
            }
            return tslib_1.__assign({}, state, { cartIndex: newCartIndex, cartProducts: tslib_1.__assign({}, state.cartProducts, (_a = {}, _a[action.payload.product] = {
                    quantity: quantity,
                    stepping: stepping,
                    relativeQuantity: relativeQuantity,
                    inCart: inCart,
                    busy: true
                }, _a)) });
        case cart.ADD_SUCCESS:
        case cart.GET_SUCCESS:
            var order_1 = action.payload;
            var cartProducts = order_1.lines.reduce(function (dict, line) {
                var _a;
                return Object.assign(dict, (_a = {},
                    _a[line.product._id] = {
                        quantity: calculateQuantity(line),
                        stepping: line.stepping,
                        relativeQuantity: calculateRelativeQuantity(line),
                        inCart: true,
                        busy: false
                    },
                    _a));
            }, tslib_1.__assign({}, state.cartProducts));
            var cartIndex = Object.keys(cartProducts);
            return tslib_1.__assign({}, state, { order: order_1,
                cartIndex: cartIndex,
                cartProducts: cartProducts });
        case checkout.SET_SUCCESS:
        case cart.CHANGE_SUCCESS:
        case cart.REMOVE_SUCCESS:
            order_1 = action.payload;
            var removeProducts = tslib_1.__assign({}, state.cartProducts);
            var removed = state.cartIndex.find(function (indexValue) {
                return order_1.lines.findIndex(function (line) { return line.product._id === indexValue; }) === -1;
            });
            if (removed)
                delete removeProducts[removed];
            return tslib_1.__assign({}, state, { order: order_1, cartIndex: Object.keys(removeProducts), cartProducts: removeProducts });
        case auth.LOGOUT:
        case cart.RESET:
            return initialState;
        default:
            return state;
    }
}
export var getOrder = function (state) { return state.order; };
export var getTotalValue = function (state) { return (state.order && state.order.subTotalPrice) || 0; };
export var getLineCount = function (state) { return (state.order && state.order.totalOrderLines) || 0; };
export var getBusyProducts = function (state) { return state.cartProducts; };
export var getCurrency = createSelector(getOrder, function (order) { return order && order.currency; });
export var getProductCount = createSelector(getOrder, function (order) {
    if (!order)
        return 0;
    return order.lines.reduce(function (count, line) { return count + line.quantity; }, 0);
});
export var getProductIds = createSelector(getOrder, function (order) { return (order && order.lines.map(function (line) { return line.product._id; })) || []; });
export var getOrderLines = createSelector(getOrder, function (order) { return order && order.lines || []; });
